import axios from "axios";

export function trackEvent(type, data = {}) {
  axios.post("analytics/event", { type, ...data }).catch(() => {});
}
